import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { WebRtcServers } from "./iceServers";
import PeerVideo from "./peerVideo";
import OtherPeerVideos from "./peerVideos";
import { HbrBroadcast, HbrCallIcon, HbrCamLiveOff, HbrCancel, HbrDropdownIcon, HbrgroupIcon, HbrLiveCam, HbrLocation, HbrMic, HbrMicOff, HbrSettingsIcon, HbrShareIcon } from "../MyCustomsvgicons";
import { DataContext } from "../DataContextProvider";
import DeviceSelection from "./deviceSelection";
import db, { realtimeDB } from "../Backend";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, onSnapshot, setDoc, updateDoc } from "firebase/firestore";
import { get, off, onValue, ref, remove, set } from "firebase/database";
import { appVariables, generateRandId, sendPairValueDataToDB, sendSingleValueDataToDB, StopMediaTracks, trimLettersFromUserName } from "../utilityClass";
import { useLocation, useNavigate } from "react-router-dom";
import UseLayout from "../UseLayout";
import CommentCollection from "../CommentCollection";
import InputComments from "../InputComment";
import ShareForm from "../newComponent/shareForm";
import { SocketIO } from "./SocketIo";
import ViewersList from "./viewersList";
import { HbrHandsUpFemale, HbrHandsUpMaleIcon } from "../largeSvgIcons";
import AlertDialog from "../newComponent/AlertMessages";


const VideoConference = () => {
    const [localStream, setLocalStream] = useState(null);
    // const [remoteStream, setRemoteStream] = useState(null);
    const {userID} = useContext(DataContext);
    const {userName} = useContext(DataContext);
    const {isAdmin} = useContext(DataContext);
    const {userLocation} = useContext(DataContext);
    const [remoteStreams, setRemoteStreams] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState({stream: null, userhandle: "", userLoc: ""});
    const [roomKey, setRoomKey] = useState("")
    const [joinMeeting, setJoinMeeting] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showAudioDevicePoppup, setShowAudioDevicePopup] = useState(false);
    const [selectedVideoDevice, setSelectedVideoDevice] = useState(null);
    const [selectedAudioDevice, setSelectedAudioDevice] = useState(null);
    const [offMic, setOffMic] = useState(false);
    const [offCam, setCamOff] = useState(false);
    const [isSoundActive, setIsSoundActive] = useState(false);
    const [muteAllmics, setMuteAllmics] = useState(false);
    const [showCommentView, setShowComment] = useState(false);
    const [broadcastStatus, setBroadcastStatus] = useState(null);
    const [showShare, setShowShare] = useState(false);
    const [peerCounts, setPeerCounts] = useState([]);
    const [programTitle, setProgramTitle] = useState("");
    const [programid, setProgramID] = useState("");
    const [peerDocRef, setPeerDocRef] = useState(null);
    const [isHost, setIsHost] = useState(null);
    const [showViewers, setShowViewers] = useState(false);
    const [unitorchaploc, setUnitorChaploc] = useState("");
    const [preferredName, setPreferredName] = useState("");
    const [canShare, setCanShare] = useState(false);
    const [openSettings, setOpenSettings] = useState(false);
    const [raisedHands, setRaisedHands] = useState(false);
    const [remoteHostWebCamIsOff, setRemoteHostWebCamStatus] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [gender, setGender] = useState("");
    const [broadCasterName, setBroadcasterName] = useState("");
    const [broadcasterLoc, setBroadCasterLoc] = useState("");
    const [hostUserId, setHostUserId] = useState("");
    const {width} = UseLayout();
    const selectDeviceRef = useRef(null);
    const mediaStreamRef = useRef(null);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const dataArrayRef = useRef(null);
    const audioRef = useRef(null);
    const videoRef = useRef(null);
    // const canvasRef = useRef(null);
    const abbreviatedName = useRef(null);
    const peerConnections = useMemo(()=> new Map(), []);
    const navigate = useNavigate();
    const location = useLocation();

    const openDevicePopup = () => setShowPopup(true);
    const closePopup = () => setShowPopup(false);
    const closeAudioDevicePopup = () => setShowAudioDevicePopup(false);
 

    const handleDeviceSelect = (deviceId, kind) => {
        if (kind === 'videoinput') {
            setSelectedVideoDevice(deviceId);
        } else if (kind === 'audioinput') {
            setSelectedAudioDevice(deviceId);
        }
    };
    
    useEffect(() => {
      if (selectedAudioDevice || selectedVideoDevice) {
        const constraints = {
          video: selectedVideoDevice ? { deviceId: { exact: selectedVideoDevice } } : true,
          audio: selectedAudioDevice ? { deviceId: { exact: selectedAudioDevice } } : true,
        };
        navigator.mediaDevices.getUserMedia(constraints)
          .then(stream => {
            if (selectDeviceRef.current) {
              selectDeviceRef.current.srcObject = stream;
              audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
              analyserRef.current = audioContextRef.current.createAnalyser();
              const source = audioContextRef.current.createMediaStreamSource(stream);
              source.connect(analyserRef.current);
              analyserRef.current.fftSize = 2048;
              dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);
              audioRef.current = stream.getAudioTracks()[0];
              videoRef.current = stream.getVideoTracks()[0];
    
              mediaStreamRef.current = stream;
            }
          })
          .catch(error => {
              console.error('Error accessing media devices.', error);
          });
      }else{
        navigator.mediaDevices.getUserMedia({video: true, audio: true})
        .then((stream) => {
          if (selectDeviceRef.current) {
            selectDeviceRef.current.srcObject = stream;
            audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
            analyserRef.current = audioContextRef.current.createAnalyser();
            const source = audioContextRef.current.createMediaStreamSource(stream);
            source.connect(analyserRef.current);
            analyserRef.current.fftSize = 2048;
            dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);
            audioRef.current = stream.getAudioTracks()[0];
            videoRef.current = stream.getVideoTracks()[0];
  
            mediaStreamRef.current = stream;
          }
        })
        .catch(error => {
            console.error('Error accessing media devices.', error);
        });
      }

    }, [selectedVideoDevice, selectedAudioDevice]);

    const createRoom = async (e) => {
      e.preventDefault();
      if (preferredName.trim() === "" || unitorchaploc.trim() === "" || programTitle === "") {
        setAlertMessage("All fields are required. Make sure you fill in all the required fields below");
        setShowAlert(true);
        return;
      }
  
      // const constraints = {
      //   video: selectedVideoDevice ? { deviceId: { exact: selectedVideoDevice } } : true,
      //   audio: selectedAudioDevice ? { deviceId: { exact: selectedAudioDevice } } : true,
      // };

      // const stream = await navigator.mediaDevices.getUserMedia(constraints);
      // audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      // analyserRef.current = audioContextRef.current.createAnalyser();
      // const source = audioContextRef.current.createMediaStreamSource(stream);
      // source.connect(analyserRef.current);
      // analyserRef.current.fftSize = 2048;
      // dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);
      // audioRef.current = stream.getAudioTracks()[0];
      // videoRef.current = stream.getVideoTracks()[0];

      // mediaStreamRef.current = stream;
      setJoinMeeting(true);
      setSelectedVideo({stream: mediaStreamRef.current, userhandle: preferredName, userLoc: unitorchaploc});
 
      const localVideoInfo = {
        id: userID,
        peerID: userID,
        userName: preferredName,
        loc: unitorchaploc,
        stream: mediaStreamRef.current
      };

      setRemoteStreams(prev => [...prev, localVideoInfo]);

      const programID = generateRandId();
      setProgramID(programID);

      set(ref(realtimeDB, `bethelcast${roomKey}`), {
        started: true,
        muteMics: true,
        allow_sharing: true,
        userName: preferredName,
        loc: unitorchaploc,
        hostid: userID,
        programTitle,
        programID
      });

      sendSingleValueDataToDB(`host/${roomKey}/${userID}`, userID);
      sendSingleValueDataToDB(`radio-program`, programID);
      SocketIO.emit("horemowgh_socket", {roomid: roomKey, userName: preferredName, userPicture:"", userid: userID, unitloc: userLocation ? userLocation : unitorchaploc});
      saveUserDetails();
      // sendSingleValueDataToDB(`host-program${roomKey}`, programTitle);
      const disconnectedPeersRef = await get(ref(realtimeDB, `disconnected${roomKey}`));
      if (disconnectedPeersRef.exists()) {
        remove(ref(realtimeDB, `disconnected${roomKey}`));
      }
    
          // Listen for new users joining the room and handle incoming connections
      onSnapshot(collection(db, `calls${roomKey}`), (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const docID = change.doc.id;
            const peerName = change.doc.data().userName;
            const peerID = change.doc.data().peerID;
            const peerLoc = change.doc.data().loc
            handleIncomingConnection(docID, peerID, peerName, peerLoc);
          }
        });
      });

      // onSnapshot(collection(db, `disconnected${roomKey}`), (snapshot) => {
      //   snapshot.docChanges().forEach((change) => {
      //     if (change.type === "added") {
      //       const docID = change.doc.id;
      //       const peerID = change.doc.data().peerID;
      //       handlePeerDisconnected(docID, peerID);
      //     }
      //   });
      // });

      // Setup the streams for the local video and the remote video
      
      // const remoteStream = new MediaStream();

      // stream.getTracks().forEach((track) => {
      //     pc.addTrack(track, stream);
      // });

      // pc.ontrack = (event) => {
      //     event.streams[0].getTracks().forEach((track) => {
      //         remoteStream.addTrack(track);
      //     });
      // };

      // setRemoteStream(remoteStream);
      // setRemoteStreams(prev => [...prev, remoteStream]);

    
        // const callDoc = doc(collection(db, `calls${roomKey}`));
        // const offerCandidates = collection(callDoc,"offerCandidates");
        // const answerCandidates = collection(callDoc,"answerCandidates");

        // console.log(callDoc.id)
        // set(ref(realtimeDB, `room${roomid}/docid`), callDoc.id);

        // try {
        //     pc.onicecandidate = (event) => {
        //         if (event.candidate) {
        //           addDoc(offerCandidates, event.candidate.toJSON());
        //         }
        //       };

        //     const offerDescription = await pc.createOffer();
        //     await pc.setLocalDescription(offerDescription);

        //     const offer = {
        //         sdp: offerDescription.sdp,
        //         type: offerDescription.type,
        //     };

        //     await setDoc(callDoc,{offer});

        //     onSnapshot(callDoc, (snapshot) => {
        //         const data = snapshot.data();
        //         if (!pc.currentRemoteDescription && data?.answer) {
        //             const answerDescription = new RTCSessionDescription(data.answer);
        //             pc.setRemoteDescription(answerDescription);
        //         }
        //     },(onerror)=>{
        //         console.log(onerror);
        //     });

        //     onSnapshot(answerCandidates, (snapshot) => {
        //         snapshot.docChanges().forEach((change) => {
        //             if (change.type === "added") {
        //                 const candidate = new RTCIceCandidate(change.doc.data());
        //                 pc.addIceCandidate(candidate);
        //             }
        //         });
        //     });
            
        //       // Listen for new users joining the room and handle incoming connections
        //     onSnapshot(collection(db, `calls${roomKey}`), (snapshot) => {
        //       snapshot.docChanges().forEach((change) => {
        //         if (change.type === "added" && change.doc.id !== callDoc.id) {
        //           const peerId = change.doc.id;
        //           handleIncomingConnection(peerId);
        //         }
        //       });
        //     });

        //     setJoinMeeting(true);
        // } catch (error) {
        //     console.log(error);
        // }
    }

    const handlePeerDisconnected=useCallback(async(peerid) => {
    if (isHost) {
      setRemoteStreams((prev)=>{
        const newStreams = prev.filter(stream => stream.peerID !== peerid);
        return newStreams;
      });
    }
    },[isHost]);

    const saveUserDetails=()=>{
      localStorage.setItem("name_id", preferredName);
      localStorage.setItem("location_id", unitorchaploc);
    }

    useEffect(()=>{
        const initialMicStatus =  ref(realtimeDB, `bethelcast${roomKey}/muteMics`);
        const broadcastInProgress =  ref(realtimeDB, `bethelcast${roomKey}/started`);
        const allowSharingRef =  ref(realtimeDB, `bethelcast${roomKey}/allow_sharing`);
        const casterNameRef =  ref(realtimeDB, `bethelcast${roomKey}/userName`);
        const casterIdRef =  ref(realtimeDB, `bethelcast${roomKey}/hostid`);
        const casterLocRef =  ref(realtimeDB, `bethelcast${roomKey}/loc`);
        const programTitleRef = ref(realtimeDB, `bethelcast${roomKey}/programTitle`);
        const programIdRef = ref(realtimeDB, `bethelcast${roomKey}/programID`);
        const hostRef = ref(realtimeDB, `host/${roomKey}/${userID}`);
        const peerDisconnectedRef = ref(realtimeDB, `disconnected${roomKey}`);
        const connectedPeersRef = ref(realtimeDB, `socket${roomKey}`);
        
        const hostWebCamRef = ref(realtimeDB, `roompeers${roomKey}/${hostUserId}/camoff`);

        const onProgramTitle = onValue(programTitleRef, (snapshot)=>{
          if (snapshot.exists()) {
            setProgramTitle(snapshot.val());
          }
        });
        const onProgramID = onValue(programIdRef, (snapshot)=>{
          if (snapshot.exists()) {
            setProgramID(snapshot.val());
          }
        });

        const micListener = onValue(initialMicStatus, (snapshot)=>{
          if (snapshot.exists()) {
            setMuteAllmics(snapshot.val());
          }
        });

        const broadcastListener = onValue(broadcastInProgress, (snapshot)=>{
          if (snapshot.exists() && snapshot.val() === false) {
              setBroadcastStatus(`live broadcast ended. Thanks for joining us.`);
          }else{
            setBroadcastStatus(null);
          }
        });

        const onAllowSharing = onValue(allowSharingRef, (snapshot)=>{
          if (snapshot.exists()) {
              setCanShare(snapshot.val());
          }
        });

        const hostListener = onValue(hostRef, (snapshot)=>{
            if (snapshot.exists()) {
                setIsHost("true");
            }
        });
        const onCasterName = onValue(casterNameRef, (snapshot)=>{
            if (snapshot.exists()) {
                setBroadcasterName(snapshot.val());
            }
        });
        const onCasterLocation = onValue(casterLocRef, (snapshot)=>{
            if (snapshot.exists()) {
                setBroadCasterLoc(snapshot.val());
            }
        });
        const onHostIdRef = onValue(casterIdRef, (snapshot)=>{
          if (snapshot.exists()) {
              setHostUserId(snapshot.val());
              console.log(hostUserId);
          }
        });
        const onHostWebCamStatus = onValue(hostWebCamRef, (snapshot)=>{
          if (snapshot.exists()) {
              setRemoteHostWebCamStatus(snapshot.val());
          }
        });

        const onDisconnected = onValue(peerDisconnectedRef, (snapshot)=>{
            if (snapshot.exists()) {
                const disconnectedID = snapshot.child("peerID").val();
                handlePeerDisconnected(disconnectedID);
            }
        });
        const onConnectedPeers = onValue(connectedPeersRef, (snapshot)=>{
          if (snapshot.exists()) {
            const listofpeers = snapshot.val();
            const arrayofpeers = Object.keys(listofpeers).map((key) => ({
              id: key,
              ...listofpeers[key]
            }))
            setPeerCounts(arrayofpeers);
          }
        });

      return ()=>{
        off(initialMicStatus, 'value', micListener);
        off(broadcastInProgress, 'value', broadcastListener);
        off(hostRef, 'value', hostListener);
        off(peerDisconnectedRef, 'value', onDisconnected);
        off(connectedPeersRef, 'value', onConnectedPeers);
        off(programTitleRef, 'value', onProgramTitle);
        off(allowSharingRef, 'value', onAllowSharing);
        off(casterNameRef, 'value', onCasterName);
        off(casterLocRef, 'value', onCasterLocation);
        off(casterIdRef, 'value', onHostIdRef);
        off(hostWebCamRef, 'value', onHostWebCamStatus);
        off(programIdRef, 'value', onProgramID);
      };
    },[roomKey, userID, handlePeerDisconnected, hostUserId]);

    const memoizedViewers = useMemo(()=>peerCounts, [peerCounts]);

    const handleIncomingConnection = async (docid, peerId, peerName, peerLoc) => {
      const pc = new RTCPeerConnection(WebRtcServers);
      peerConnections.set(docid, pc);
    
      // Add tracks to the new connection
      mediaStreamRef.current.getTracks().forEach((track) => {
        pc.addTrack(track, mediaStreamRef.current);
      });

      const remoteStream = new MediaStream();

      pc.ontrack = (event) => {
          event.streams[0].getTracks().forEach((track) => {
              remoteStream.addTrack(track);
          });
      };
      const remoteVideo = {
        id: docid,
        peerID: peerId,
        userName: peerName,
        loc: peerLoc,
        stream: remoteStream
      };

      setRemoteStreams(prev => [...prev, remoteVideo]);
    
      const callDoc = doc(db, `calls${roomKey}`, docid);
      const offerCandidates = collection(callDoc, "offerCandidates");
      const answerCandidates = collection(callDoc, "answerCandidates");
    
      pc.onicecandidate = (event) => {
        if (event.candidate) {
          addDoc(answerCandidates, event.candidate.toJSON());
        }
      };

      const callSnapshot = await getDoc(callDoc);
      if (callSnapshot.exists()) {
      const callData = callSnapshot.data();
          if (callData?.offer) {
              const offerDescription = callData.offer;
              await pc.setRemoteDescription(new RTCSessionDescription(offerDescription));
          }else{
              console.error("offer data is null")
          }
          const answerDescription = await pc.createAnswer({
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
          });
          await pc.setLocalDescription(answerDescription);
          const answer = {
              type: answerDescription.type,
              sdp: answerDescription.sdp,
          };
          await updateDoc(callDoc, {answer});
      }

      onSnapshot(offerCandidates,(snapshot) => {
        snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
                let data = change.doc.data();
                pc.addIceCandidate(new RTCIceCandidate(data));
            }
        });
      });

      // pc.onconnectionstatechange = async(event) => {
      //   if (pc.connectionState === "disconnected") {
      //     try
      //     peerConnections.delete(docid);
      //   }
      // };

    };

    const joinRoom=async(e)=>{
      if (preferredName.trim() === "" || unitorchaploc.trim() === "") {
        setAlertMessage("All fields are required. Make sure you fill in all the required fields below");
        return setShowAlert(true);
      }

      const initialMicStatus = await get(ref(realtimeDB, `bethelcast${roomKey}/muteMics`));
      const broadcastInProgress = await get(ref(realtimeDB, `bethelcast${roomKey}/started`));
      if (!broadcastInProgress.exists() || broadcastInProgress.val() === false) {
        setAlertMessage(`no live broadcast in seesion for meeting Id: ${roomKey}`);
        return setShowAlert(true);
      }

      if (initialMicStatus.exists()) {
        setMuteAllmics(initialMicStatus.val());
        audioRef.current.enabled = false;
        setOffMic(true);
        sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/micoff`, true);
      }
  

      const pc = new RTCPeerConnection(WebRtcServers);
      peerConnections.set(userID, pc);
      e.preventDefault();

      // const constraints = {
      //   video: selectedVideoDevice ? { deviceId: { exact: selectedVideoDevice } } : true,
      //   audio: selectedAudioDevice ? { deviceId: { exact: selectedAudioDevice } } : true,
      // };

      // const stream = await navigator.mediaDevices.getUserMedia(constraints);
      // audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      // analyserRef.current = audioContextRef.current.createAnalyser();
      // const source = audioContextRef.current.createMediaStreamSource(stream);
      // source.connect(analyserRef.current);
      // analyserRef.current.fftSize = 2048;
      // dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);
      // audioRef.current = stream.getAudioTracks()[0];
      // videoRef.current = stream.getVideoTracks()[0];
      // mediaStreamRef.current = stream;

      // Setup the streams for the local video and the remote video
      setLocalStream(mediaStreamRef.current);

      const remoteStream = new MediaStream();

      mediaStreamRef.current.getTracks().forEach((track) => {
          pc.addTrack(track, mediaStreamRef.current);
      });

      pc.ontrack = (event) => {
          event.streams[0].getTracks().forEach((track) => {
              remoteStream.addTrack(track);
          });
      };

      // setSelectedVideo({stream: remoteStream, userhand});
      setSelectedVideo({stream: remoteStream, userhandle: broadCasterName, userLoc: broadcasterLoc});
      setJoinMeeting(true);

      try {
        // if (!roomIsFull) {
        //   const callDoc = doc(db,`calls${roomKey}`,roomid);
        //   // const callDoc2 = doc(db,"calls");
        //   const offerCandidates = collection(callDoc,"offerCandidates");
        //   const answerCandidates = collection(callDoc,"answerCandidates");

        //   pc.onicecandidate = (event) => {
        //     if (event.candidate) {
        //       addDoc(answerCandidates, event.candidate.toJSON());
        //     }
        //   };

        // const callSnapshot = await getDoc(callDoc);
        // if (callSnapshot.exists()) {
        // const callData = callSnapshot.data();
        //     if (callData?.offer) {
        //         const offerDescription = callData.offer;
        //         await pc.setRemoteDescription(new RTCSessionDescription(offerDescription));
        //     }else{
        //         console.error("offer data is null")
        //     }
        //     const answerDescription = await pc.createAnswer();
        //     await pc.setLocalDescription(answerDescription);
        //     const answer = {
        //         type: answerDescription.type,
        //         sdp: answerDescription.sdp,
        //     };
        //     await updateDoc(callDoc, {answer});

        // }
        
        // onSnapshot(offerCandidates,(snapshot) => {
        //     snapshot.docChanges().forEach((change) => {
        //         if (change.type === "added") {
        //             let data = change.doc.data();
        //             pc.addIceCandidate(new RTCIceCandidate(data));
        //         }
        //     });
        // });

        // setJoinMeeting(true);
        // set(ref(realtimeDB, `room${roomKey}/peers`), 2);

        // }else{
          
          
        // }
        const callDoc2 = doc(collection(db, `calls${roomKey}`));
        const offerCandidates = collection(callDoc2,"offerCandidates");
        const answerCandidates = collection(callDoc2,"answerCandidates");

        setPeerDocRef(callDoc2.id);

        pc.onicecandidate = (event) => {
          if (event.candidate) {
            addDoc(offerCandidates, event.candidate.toJSON());
          }
        };

        const offerDescription = await pc.createOffer({
          offerToReceiveAudio: true,
          offerToReceiveVideo: true
        });
        await pc.setLocalDescription(offerDescription);

        const offer = {
            sdp: offerDescription.sdp,
            type: offerDescription.type,
        };

        await setDoc(callDoc2,{
          offer,
          peerID: userID,
          userName: preferredName,
          loc: unitorchaploc,
        });

        onSnapshot(callDoc2, (snapshot) => {
          const data = snapshot.data();
          if (!pc.currentRemoteDescription && data?.answer) {
              const answerDescription = new RTCSessionDescription(data.answer);
              pc.setRemoteDescription(answerDescription);
          }
      },(onerror)=>{
          setShowAlert(true);
          setAlertMessage("Unable to establish connection with the Host. Try refreshing the app or check your internet connection. Ignore this message if connection is restored");
      });

      onSnapshot(answerCandidates, (snapshot) => {
          snapshot.docChanges().forEach((change) => {
              if (change.type === "added") {
                  const candidate = new RTCIceCandidate(change.doc.data());
                  pc.addIceCandidate(candidate);
              }
          });
      },(onerror)=>{
        setShowAlert(true);
        setAlertMessage("Unable to establish connection with the Host. Try refreshing the app or check your internet connection. Ignore this message if connection is restored");
      });
      SocketIO.emit("horemowgh_socket", {roomid: roomKey, userName: preferredName, userPicture:"", userid: userID, unitloc: unitorchaploc});
      saveUserDetails();
      } catch (error) {
        setShowAlert(true);
        setAlertMessage("Unable to establish connection with the Host. Try refreshing the app or check your internet connection. Ignore this message if connection is restored");
      }
    }

    const handleSwitchVideo=(vidstream, userhandle, userLoc)=>{
      setSelectedVideo({stream: vidstream, userhandle, userLoc});
    };

    const endBroadcast=async()=>{
      try {
        if (peerConnections.size > 0) {
          // eslint-disable-next-line
          for (let [docid, pc] of peerConnections) {
            pc.close();
          }
        }

        if (!isHost) { 
          let offerAnswerRef = doc(db, `calls${roomKey}`, peerDocRef);
          const answerCandidatesRef = await getDocs(collection(offerAnswerRef, "answerCandidates"));
          const offerCandidatesRef = await getDocs(collection(offerAnswerRef, "offerCandidates"));
          answerCandidatesRef.forEach(async (doc) => {
            await deleteDoc(doc.ref);
          });
          offerCandidatesRef.forEach(async (doc) => {
            await deleteDoc(doc.ref);
          });
          await deleteDoc(offerAnswerRef);
          sendPairValueDataToDB(`disconnected${roomKey}`, {
            peerID: userID,
            userName: preferredName
          });
        }

        if (isHost) {
          try {
            const roomIdRef = await getDocs(collection(db, `calls${roomKey}`));
            roomIdRef.forEach(async (doc) => {
              await deleteDoc(doc.ref);
            });
          } catch (error) {
            console.log(error);
          }
          const roomCommentsRef = ref(realtimeDB, `bethelcast-comments${roomKey}`); 
          remove(roomCommentsRef);
          sendSingleValueDataToDB(`bethelcast${roomKey}/started`, false);
        };

        SocketIO.emit("auto_disconnect", {roomid: roomKey, userid: userID});
        
        if (mediaStreamRef.current) {
            StopMediaTracks(mediaStreamRef.current);
        }
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
      } catch (error) {
        console.log(error);
      }
    };

    const controlAudio=(control)=>{
      if (!muteAllmics) {
        try {
          if (control === "mute") {
              audioRef.current.enabled = false;
              setOffMic(true);
              sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/micoff`, true);
          }else if(control === "unmute"){
              audioRef.current.enabled = true;
              setOffMic(false);
              sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/micoff`, false);
          }
        } catch (error) {
            console.log(error)
        }  
      }else{
        if (isHost) {
          try {
            if (control === "mute") {
                audioRef.current.enabled = false;
                setOffMic(true);
                sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/micoff`, true);
            }else if(control === "unmute"){
                audioRef.current.enabled = true;
                setOffMic(false);
                sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/micoff`, false);
            }
          } catch (error) {
              console.log(error)
          }  
        }else{
          setShowAlert(true);
          setAlertMessage("Host has disabled all particpants mic. Use the reaction button or ask host to unmute in comment");
        }
      }
            
    };

    const controlVideo=(control)=>{
          try {
              if (control === "off") {
                  videoRef.current.enabled = false;
                  setCamOff(true);
                  sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/camoff`, true);
              }else if(control === "on"){
                  videoRef.current.enabled = true;
                  setCamOff(false);
                  sendSingleValueDataToDB(`roompeers${roomKey}/${userID}/camoff`, false);
              }
          } catch (error) {
              console.log(error);
          }     
    };

    // const drawAudioLevels = useCallback(()=>{
    //   const canvas = canvasRef.current;
    //   if (canvas) {
    //     const ctx = canvas.getContext('2d');
    //     const WIDTH = canvas.width;
    //     const HEIGHT = canvas.height;
    //     ctx.clearRect(0, 0, WIDTH, HEIGHT);
    //     if (analyserRef.current) {
    //       analyserRef.current.getByteTimeDomainData(dataArrayRef.current);
    //       ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
    //       ctx.fillRect(0, 0, WIDTH, HEIGHT);

    //       const barWidth = WIDTH / dataArrayRef.current.length;
    //       let barHeight;
    //       let x = 0;
    //       for (let i = 0; i < dataArrayRef.current.length; i++) {
    //         barHeight = dataArrayRef.current[i] / 2;
    //         ctx.fillStyle = 'rgb(' + (barHeight + 100) + ', 50, 50)';
    //         ctx.fillRect(x, HEIGHT - barHeight / 2, barWidth, barHeight);
    //         x += barWidth + 1;
    //       }
    //   }
    //   }
    // },[]);
        
    const startAudioAnalysis = useCallback(()=>{
        const checkAudio = () =>{
            if (analyserRef.current) {
                analyserRef.current.getByteTimeDomainData(dataArrayRef.current);
                const isSound = dataArrayRef.current.some(value => value > 126 + 10 || value < 128 - 10);
                setIsSoundActive(isSound);
                // if (isSound) {
                 
                // }
               if (joinMeeting) {
                requestAnimationFrame(checkAudio);
                // drawAudioLevels()
               }
              
            }
        };
        checkAudio();
    },[joinMeeting]);
  
    useEffect(()=>{
        startAudioAnalysis();
    },[startAudioAnalysis]);

    useEffect(()=>{
      if (offCam && abbreviatedName.current) {
        trimLettersFromUserName(preferredName, abbreviatedName.current);
      }
      if (remoteHostWebCamIsOff && abbreviatedName.current) {
        trimLettersFromUserName(broadCasterName, abbreviatedName.current);
      }
    },[preferredName, offCam, isHost, broadCasterName, remoteHostWebCamIsOff]);

    const toggleParticipantsMic=(e)=>{
      if (e.target.checked) {
        sendSingleValueDataToDB(`bethelcast${roomKey}/muteMics`, true);
        setMuteAllmics(true);
      }else{
        sendSingleValueDataToDB(`bethelcast${roomKey}/muteMics`, false);
        setMuteAllmics(false);
      }
    };
    const toggleSharingFeature=(e)=>{
      if (e.target.checked) {
        sendSingleValueDataToDB(`bethelcast${roomKey}/allow_sharing`, true);
        setCanShare(true);
      }else{
        sendSingleValueDataToDB(`bethelcast${roomKey}/allow_sharing`, false);
        setCanShare(false);
      }
    };

    const sendHandsUpSignal=(genderType)=>{
      setRaisedHands(prev => {
        const newStatus = !prev;
        sendPairValueDataToDB(`roompeers${roomKey}/${userID}/handsUp`,{
          raised: newStatus,
          genderType
        });
        return newStatus;
      });
      setGender(genderType);
    };

    const handleShareMeeting=()=>{
      if (canShare) {
        setShowShare(true);
      }else{
        if (isHost) {
          setShowShare(true);
        }else{
          setShowAlert(true);
          setAlertMessage("Host has disabled sharing of this meeting. This feature is usually activated if the meeting is private");
        }
      }
    };

      
    return joinMeeting ? ( 
        <div className="bethel-broadcast">

          <div className="bethel-video-feed flex-column1">

                <div className={`pinned-video ${isHost ? 'admin':'regular'}`}>
                      <div style={{position:"absolute", left:"0px", right:"0px", bottom:"0px", top:"0px", width:"100%", height:"100%"}}>
                    
                        {!offCam ? 
                           <PeerVideo 
                           videoStream={selectedVideo.stream}
                           mute={isHost ? true : false}
                           />
                          :
                          isHost ?
                          <div className={`inactive-webcam flex-column2`}>
                            <p className="inactive-webcam-name-admin flex-column2" ref={abbreviatedName}></p>
                          </div>
                          :
                          <PeerVideo 
                          videoStream={selectedVideo.stream}
                          mute={isHost ? true : false}
                          />
                        }

                      </div>

                      
                      {!isHost && remoteHostWebCamIsOff && 
                          <div className={`remote-host-webcam-off flex-column2`}>
                             <p className="remote-host-webcam-name flex-column2" ref={abbreviatedName}></p>
                         </div>
                        }

                    
                      <div className={`user-pinned-video-details ${isHost ? 'admin' : 'regular'} flex-row2`}>
                        <h4 style={{color:"white"}}>{isHost ? selectedVideo.userhandle : 'Host - ' + selectedVideo.userhandle}</h4>
                        <HbrLocation width={"1.5em"} height={"1.5em"} fillColour={"white"}/>
                        <h4 style={{color:"white"}}>{selectedVideo.userLoc}</h4>
                      </div>
                      
                    
                      <div className="peer-counts flex-row2" onClick={()=>setShowViewers(prev => !prev)}>
                        <HbrgroupIcon width={"1.7em"} height={"1.7em"} fillColour={"white"}/>
                        <h4 style={{color:"white", fontSize:"small"}}>{peerCounts ? peerCounts.length : 'waiting for others...'}</h4>
                      </div>

                      {showViewers && 
                        <div className="show-viewers-list flex-column1">
                          <div className="flex-spacearound" style={{width:"100%"}}>
                            <h3>Online</h3>
                            <HbrCancel width={"1.7em"} height={"1.7em"} fillColour={"black"} handleClick={()=>setShowViewers(false)}/>
                          </div>

                          {memoizedViewers && memoizedViewers.map((data, index) => (
                            <ViewersList
                            key={index}
                            userName={data.userName}
                            userid={data.userid}
                            unitloc={data.unitloc}
                            ishost={isHost}
                            />
                          ))}
                        </div>
                      }

                    {broadcastStatus && 
                        <div className="broadcast-status flex-row2">
                        <HbrBroadcast width={"2em"} height={"2em"} fillColour={"white"}/>
                        <h4 style={{color:"white"}}>{broadcastStatus ? broadcastStatus : ""}</h4>
                    </div>
                    }

                    {openSettings && 
                      <div className="bethel-cast-settings flex-column2">
                          <HbrCancel width={"1.7em"} height={"1.7em"} fillColour={"black"} handleClick={()=>setOpenSettings(false)}/>
                          <div className="flex-row2" style={{gap:"2em"}}>
                            <input type="checkbox" id="allow-to-speak" checked={muteAllmics} onChange={toggleParticipantsMic}/>
                            <label htmlFor="allow-to-speak">
                                <h3>{muteAllmics ? "All participants are muted. click to allow them to unmute":"Mute all particpants"}</h3>
                            </label>
                          </div>

                          <div className="flex-row2" style={{gap:"2em"}}>
                            <input type="checkbox" id="allow-to-share" checked={canShare} onChange={toggleSharingFeature}/>
                            <label htmlFor="allow-to-share">
                                <h3>
                                  {canShare ? "All participants can share this meeting. click to disallow them":"Allow particiapnts to share meeting forum"}

                                </h3>
                            </label>
                          </div>
                      </div>
                    }

                    <div className={`meeting-buttons ${isHost ? 'admin':'regular'}`}>
                        <div className="flex-row2" style={{width:"100%", gap:"20px"}}>
                          {/* <canvas ref={canvasRef} width={50} height={100}></canvas> */}
                            {offMic ? 
                              (<div><HbrMicOff width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={() => controlAudio("unmute")} /></div>)
                              :
                              (<div className={`bethel-mic ${isSoundActive ? 'active':'dormant'}`}>
                                  <HbrMic width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={() => controlAudio("mute")}/>
                              </div>
                              )}

                            {offCam ? 
                              (<div><HbrCamLiveOff width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={() => controlVideo("on")} /></div>)
                              :
                              (<div>
                                  <HbrLiveCam width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={() => controlVideo("off")}/>
                              </div>
                              )}

                              <HbrShareIcon width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={()=>handleShareMeeting()}/>

                              {isHost && <HbrSettingsIcon 
                              width={width <= 1110 ? '1.5em':'2em'} 
                              height={width <= 1110 ? '1.5em':'2em'} 
                              fillColour={"white"} 
                              handleClick={()=>setOpenSettings(prev => !prev)}/>}

                              {!isHost && <HbrHandsUpMaleIcon 
                              width={width <= 1110 ? '1.5em':'2em'} 
                              height={width <= 1110 ? '1.5em':'2em'} 
                              handleClick={()=>sendHandsUpSignal("male")}
                              />}

                              {!isHost && <HbrHandsUpFemale 
                              width={width <= 1110 ? '1.5em':'2em'} 
                              height={width <= 1110 ? '1.5em':'2em'} 
                              handleClick={()=>sendHandsUpSignal("female")}
                              />}

                              <div style={{background:"red", borderRadius: "50%", padding:"10px"}} onClick={endBroadcast}>
                                <HbrCallIcon width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} />
                              </div>
                        </div>
            
                    </div>

                      {!isHost && 
                        <div className={`peer-local-video ${width > 1110 ? 'desktop':'mobile'}`}>
                          {!offCam ? 
                                <PeerVideo 
                                videoStream={localStream}
                                mute={true}
                                />
                                :
                                <div className={`inactive-webcam flex-column2`}>
                                <p className="inactive-webcam-name flex-column2" ref={abbreviatedName}></p>
                              </div>
                          }

                          <div className={`hand-gesture-on-single-peer ${width > 1110 ? 'desktop':'mobile'}`}>
                            {raisedHands && gender === "male" ? 
                            <HbrHandsUpMaleIcon
                            width={'2em'} 
                            height={'2em'}
                            />
                            :
                            raisedHands && gender === "female" ?
                            <HbrHandsUpFemale
                            width={'2em'} 
                            height={'2em'}
                            />
                            :
                            <p>{""}</p>
                            }
                        </div>

                        </div>
                      }
                  </div>

                {isHost && 
                    <div>
                    <OtherPeerVideos 
                        remoteStreams={remoteStreams}
                        switchVideo={handleSwitchVideo}
                        roomKey={roomKey}
                    />
                  </div>
                }
          </div>

          {width > 1110 ?
               <div className={`bethel-commentview-desktop flex-column1`}>
               <div className="commentviewtop flex-spacearound" style={{width:"100%", height:"10%"}}>
                   <h4>Share</h4>
                   <HbrShareIcon width={"2em"} height={"2em"} handleClick={()=>handleShareMeeting()}/>
               </div>

               <CommentCollection programID={programid} roomKey={roomKey}/>
               <InputComments userName={preferredName} programID={`${programid}`} roomKey={roomKey}/>
           </div>
            :
            <div className={`bethel-commentview-mobile flex-column1`}>
              {showCommentView && 
               <div className="flex-spacearound" style={{width:"100%", height:"50px"}}>
                <h4 style={{color:"white", fontSize:"small"}}>Comments</h4>
               <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>setShowComment(false)}/>
              </div>
              }
              
              {showCommentView && <CommentCollection programID={programid} roomKey={roomKey}/>}
              <InputComments
              userName={preferredName}
              roomKey={roomKey}
              openCommentsView={()=>setShowComment(true)}
              closeCommentsView={() => setShowComment(false)}
              programID={programid}
              />
          </div>
          }
       
          {showShare && 
              <ShareForm
              callToAction={`Join our realtime video streaming platform for ${programTitle} on bethel cast`}
              formTitle={"share to connect friends, families and loved ones"}
              title={"Bethel cast"}
              url={`${appVariables.APP_URL}/bethelcast`}
              closeForm={()=>setShowShare(false)}
              showMoreOptions={true}
              />
          }

          {showAlert && 
            <AlertDialog 
              dialogMessage={alertMessage}
              closeDialog={()=>setShowAlert(false)}
            />
          }
          
        </div>
     ):(
        <div className={`meeting-home`} style={{background:"black", width:"100%", height:"100vh"}}>

          <div className="bethel-cast-brand flex-row2">
            <h2 style={{color:"white"}}>Bethel Cast</h2>
          </div>

          <form className="meeting-setup-form flex-column2">
            <fieldset>
              <legend>Cast Id:</legend>
            <input type="text" placeholder="enter cast ID" required value={roomKey} onChange={e => setRoomKey(e.target.value.trim())}/>
            </fieldset>

            {isAdmin && 
              <fieldset>
                <legend>Cast description:</legend>
                <input type="text" 
                placeholder="enter your program title" 
                required value={programTitle} 
                onChange={e => setProgramTitle(e.target.value)}/>
              </fieldset>
            }
            
            <fieldset>
              <legend onClick={()=>setPreferredName(userName)}>Your name {userName ? userName : "e.g Ama Manso"}</legend>
              <input type="text" placeholder={userName ? "click on your displayed name to auto fill" : "preferred Name"}
              required 
              value={preferredName}
              onChange={e => {
                if (e.target.value.trim().length <= 16) {
                  setPreferredName(e.target.value);
                }
              }}
              />
            </fieldset>

            <fieldset>
              <legend onClick={()=>setUnitorChaploc(userLocation)}>Location: {userLocation ? userLocation : "Unit/Chapter/Residence"}</legend>
              <input type="text" placeholder={userLocation ? "click on your unit name to auto fill" : "unit or chapter location"}
                required value={unitorchaploc} 
                onChange={e => setUnitorChaploc(e.target.value.trim())}
              />
            </fieldset>

            {isAdmin && 
              <button className="buttonstyle" style={{color:"white", backgroundColor:"blue"}} onClick={createRoom}>
              start broadcast
            </button>
            }
            <button className="buttonstyle" style={{color:"white", backgroundColor:"blue"}} onClick={joinRoom}>
                watch broadcast
            </button>
          </form>

          <div className="video-capture-meeting flex-column2" style={{backgroundColor:"#252a41"}}>
                <div className="webcam-audio-selection flex-spacearound" style={{width:"100%"}}>
                    
                      <div className="flex-row2" style={{position:"relative", gap:"10px"}}>
                        <h3 style={{color:"white"}}>video capture</h3>
                          <HbrDropdownIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>openDevicePopup()}/>
                          {showPopup && 
                          <div className="device-popup-view">
                              <DeviceSelection onDeviceSelected={handleDeviceSelect} closeDevicesPopup={closePopup} deviceKind={"video"}/>
                          </div>
                          }
                      </div>

                      <div className="flex-row2" style={{position:"relative", gap:"10px"}}>
                        <h3 style={{color:"white"}}>Microphone</h3>
                          <HbrDropdownIcon width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>setShowAudioDevicePopup(true)}/>
                          {showAudioDevicePoppup && 
                            <div className="device-popup-view">
                                <DeviceSelection onDeviceSelected={handleDeviceSelect} closeDevicesPopup={closeAudioDevicePopup} deviceKind={"audio"}/>
                            </div>
                          }
                      </div>
                </div>

                <div className="flex-spacearound" style={{width:"100%"}}>
                  {/* <canvas ref={canvasRef} width={400} height={200}></canvas> */}
                  {/* <div className="flex-column1">
                      {offMic ? 
                              (<div><HbrMicOff width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={() => controlAudio("unmute")} /></div>)
                              :
                              (<div className={`bethel-mic ${isSoundActive ? 'active':'dormant'}`}>
                                  <HbrMic width={width <= 1110 ? '1.5em':'2em'} height={width <= 1110 ? '1.5em':'2em'} fillColour={"white"} handleClick={() => controlAudio("mute")}/>
                              </div>
                              )}
                          <button style={{background: "white"}}>{`${offMic ? 'unmute': 'mute'}`}</button>
                  </div> */}
                </div>
                
                <video ref={selectDeviceRef} autoPlay playsInline muted/>
          </div>
          {showAlert && 
            <AlertDialog 
              dialogMessage={alertMessage}
              closeDialog={()=>setShowAlert(false)}
            />
          }
        </div>
     )
}
export default VideoConference;